import { useQuery, useQueryClient } from '@tanstack/react-query';
import { ProjectView } from '@lib/api-interface';
import { ResourceQueryService } from '@lib/common-sdk';

export const useProjectView = (projectId: string | undefined) => {
  const queryKey = ['projectViews', projectId];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: queryKey,
    queryFn: (context) => {
      return ResourceQueryService.findOneByField<ProjectView>('/api/resource/projectViews', 'projectId', projectId);
    },
    staleTime: 3000,
  });

  const invalidateQuery = async () => {
    await queryClient.invalidateQueries({ queryKey: queryKey });
  };

  return [query, invalidateQuery] as const;
};
